import { FC } from 'react';
import { useSingleCourse } from '@new/features/courses/contexts/SingleCourseProvider';
import { Progress } from '@new/common/ui/Progress/Progress';
import { ExamActionCard } from './ExamActionCard';
import { LockedChip } from '@new/common/ui/Chip/LockedChip';
import { StepMessage } from '../StepMessage';

export const EmptyExamState: FC = () => {
  const { course } = useSingleCourse();

  const isLocked =
    course?.selfAssessmentCompletionPercentage !== undefined &&
    course.selfAssessmentCompletionPercentage < 100;

  const actionCardBackgroundColor = isLocked ? 'bg-(--neutral-black-NB100)' : 'bg-(--primary-O200)';

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-2">
        {isLocked && (
          <StepMessage
            variant="warning"
            message="You need to complete the Self Assessment step first. Review all lesson objectives and mark each one as completed to unlock the Course Exam."
          />
        )}
        <div className="flex flex-col gap-1 lg:flex-row lg:items-center lg:justify-between">
          <span className="flex gap-2 items-center [font-size:var(--fs-p4)]! text-(--neutral-black-NB500)!">
            Your progress {isLocked && <LockedChip />}
          </span>

          <span className="[font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! font-medium text-(--neutral-black-NB600)!">
            No questions answered yet
          </span>
        </div>

        <Progress value={0} className="h-3 lg:h-4.75 w-full" />
      </div>

      <ExamActionCard
        title="Ready for Exam?"
        description="Take exam to unlock the next step."
        buttonText="Take Exam"
        backgroundColor={actionCardBackgroundColor}
        disabled={isLocked}
      />
    </div>
  );
};
